import type { QueryClient } from '@tanstack/react-query'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { Toaster } from 'sonner'

import { Button } from '@/components/ui/primitives'

export interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
})

function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster position="bottom-right" richColors closeButton />
    </>
  )
}

function NotFound() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center">
      <p className="font-display text-2xl font-bold text-ink">Страница не найдена</p>
      <p className="text-sm text-ink-subtle">Возможно, ссылка устарела или содержит опечатку.</p>
      <Button variant="primary" onClick={() => (window.location.href = '/')}>
        На главную
      </Button>
    </div>
  )
}
